import React from 'react';
import { useLoading } from '../../contexts/LoadingContext';
import LoadingSpinner from './LoadingSpinner';

const GlobalLoadingOverlay = () => {
  const { isNavigating, isPageLoading } = useLoading();

  // Show overlay for navigation or initial page load
  if (!isNavigating && !isPageLoading) return null;

  const getLoadingMessage = () => {
    if (isNavigating) return 'Loading page...';
    if (isPageLoading) return 'Loading...';
    return 'Loading...';
  };

  return (
    <div className="fixed inset-0 bg-white bg-opacity-90 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-8">
        <LoadingSpinner 
          size="large" 
          message={getLoadingMessage()} 
          className="min-h-[200px]"
        />
      </div>
    </div>
  );
};

export default GlobalLoadingOverlay;
